/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */

import { fabric } from 'fabric';
import { generateId, getPathValue, setPathDimensions } from '../../utils';
import { FABRIC_CUSTOM_OBJECT, MINIMUM_SIZE_SCALING } from '../../utils/constants';

const CURLY_BRACKETS = {
  name: 'Curly Brackets',
  path: 'M 0 160 C 5.52 160 10 155.52 10 150 V 90 C 10 84.48 14.48 80 20 80 C 14.48 80 10 75.52 10 70 V 10 C 10 4.48 5.52 0 0 0',
};
const ROUND_BRACKETS = { name: 'Round Brackets', path: 'M 0 0 H 16.821 V 100 H 0' };
const SQUARE_BRACKETS = {
  name: 'Square Brackets',
  path: 'M 0 0 A 13.473 13.473 0 0 1 13.473 13.473 V 86.529 A 13.473 13.473 0 0 1 0 100',
};
const ANGLE_BRACKETS = { name: 'Angle Brackets', path: 'M 0 0 L 14.73 49.67 L 0 100' };

const createComponent = (root) => {
  let path = '';
  switch (root.pathStyle.name) {
    case CURLY_BRACKETS.name:
      path = CURLY_BRACKETS.path;
      break;
    case ROUND_BRACKETS.name:
      path = ROUND_BRACKETS.path;
      break;
    case SQUARE_BRACKETS.name:
      path = SQUARE_BRACKETS.path;
      break;
    default:
      path = ANGLE_BRACKETS.path;
      break;
  }
  const tmp = new fabric.Path(path, {
    width: 100,
    height: 100,
    objectCaching: false,
    selectable: false,
    fill: 'transparent',
    strokeWidth: root.strokeWidth,
    stroke: '#000',
    maxWidth: 20,
  });
  const d = getPathValue(tmp);
  const updatedPathString = setPathDimensions(
    d,
    Math.max(root.width, MINIMUM_SIZE_SCALING),
    Math.max(root.height, MINIMUM_SIZE_SCALING),
    tmp.maxWidth,
  );
  return new fabric.Path(updatedPathString, {
    ...tmp,
  });
};

fabric.Brackets = fabric.util.createClass(fabric.Rect, {
  type: FABRIC_CUSTOM_OBJECT.brackets,
  initialize(options) {
    options || (options = {});
    this.callSuper('initialize', options);
    this.set('name', options.pathStyle.name);
    this.set('isContainer', true);
    this.set('pathStyle', { ...options.pathStyle });
    this.set('id', options.id || generateId());
    this.set('type', FABRIC_CUSTOM_OBJECT.brackets);
    this.set({ lockRotation: true });
    this.on('scaling', () => {
      const width = this.width * this.scaleX;
      const height = this.height * this.scaleY;
      this.set({
        scaleX: 1,
        scaleY: 1,
        width,
        height,
        flipX: false,
        flipY: false,
      });
      this.setCoords();
    });
  },
  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.get('id'),
      isContainer: this.get('isContainer') || true,
      pathStyle: this.get('pathStyle'),
    });
  },
  toSVG() {
    let svgString = '';
    const component = createComponent(this);
    component.set({
      flipX: false,
      left: this.width / 2 - component.maxWidth - this.strokeWidth / 2,
      top: -this.height / 2 - this.strokeWidth / 2,
    });
    svgString += component.toSVG();
    component.set({
      flipX: true,
      left: -this.width / 2 - this.strokeWidth + this.strokeWidth / 2,
      top: -this.height / 2 - this.strokeWidth / 2,
    });
    svgString += component.toSVG();
    return svgString;
  },
  _render(ctx) {
    const component = createComponent(this);
    component.set({
      flipX: false,
      left: this.width / 2 - component.maxWidth - this.strokeWidth / 2,
      top: -this.height / 2 - this.strokeWidth / 2,
    });
    component.render(ctx);
    component.set({
      flipX: true,
      left: -this.width / 2 - this.strokeWidth + this.strokeWidth / 2,
      top: -this.height / 2 - this.strokeWidth / 2,
    });
    component.render(ctx);
  },
});

fabric.Brackets.fromObject = function (options, callback) {
  return callback(new fabric.Brackets(options));
};

window.fabric.Brackets = fabric.Brackets;

export default fabric.Brackets;

export function createCustomObj() {
  const rect = new fabric.Brackets({
    name: 'Swim lane Vertical',
    width: 200,
    height: 200,
    stroke: '#000000',
    strokeWidth: 2,
    fill: 'transparent',
  });
  return rect;
}
